export default __webpack_public_path__ + "static/media/icon-grubhub.68a7a141.svg";